const normalizePartnerData = (
  data: unknown
): (string | number)[] => {
  if (Array.isArray(data)) {
    return data;
  }

  if (typeof data === 'object' && data !== null) {
    const sparseRow = data as Record<string, string | number>;
    const indices = Object.keys(sparseRow).map(Number);
    const columnCount = indices.length ? Math.max(...indices) + 1 : 1;
    const dense = new Array(columnCount).fill(0) as (string | number)[];
    dense[0] = '';

    Object.entries(sparseRow).forEach(([index, value]) => {
      dense[Number(index)] = value;
    });

    return dense;
  }

  return [];
};

const createPartnersArray = (partnerObject: Record<string, unknown> | unknown[]) => {
  if (Array.isArray(partnerObject)) {
    return partnerObject.map((partner: any) => ({
      ...partner,
      data: normalizePartnerData(partner?.data),
    }));
  }

  if (typeof partnerObject === 'object' && partnerObject !== null) {
    return Object.entries(partnerObject).map(([key, value]) => ({
      id: key,
      data: normalizePartnerData(value),
    }));
  }

  return [];
};
export default createPartnersArray;
